import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Form from "../../../../shared/components/Form"
import Input from "../../../../shared/components/Input";
import { faArrowLeft, faArrowRight, faCopy, faEdit, faEllipsisH, faFileDownload, faFileExcel, faIdBadge, faPlus, faTimes, faTimesCircle, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { formatDate } from "../../../../util/date";
import { useRef, useState } from "react";
import { toast } from "react-toastify";

import "./styles.css";
import UploadForm from "./UploadForm";
const EVENT_TYPES = [
  {
    label: "Conference",
    value: "Conference",
  },
  {
    label: "Seminar",
    value: "Seminar",
  },
  {
    label: "Training",
    value: "Training",
  },
  {
    label: "Webinar",
    value: "Webinar",
  }
];
const EVENT_STATUSES = [
  {
    label: "Pending",
    value: "Pending",
  },
  {
    label: "Confirmed",
    value: "Confirmed",
  },
  {
    label: "In-Progress",
    value: "In-Progress",
  },
  {
    label: "Completed",
    value: "Completed",
  },
  {
    label: "Canceled",
    value: "Canceled",
  },
];

function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const EventForm = ({ toggleSendEmail, toggleEvaluation, handleUpload, activeAttendees = [], refetchAttendees, defaultValues = {}, title, readOnly, activateForm, onChange, onSubmit, onBack, copyLink, downloadCertificates, exportAttendees }) => {
  const { name, type, price, venue, status, id, magic_link, schedules: stringifyScheds = "[{}]", topics: stringifyTopics = "[]" } = defaultValues;
  const schedules = JSON.parse(stringifyScheds);
  const topics = JSON.parse(stringifyTopics);
  const [isActiveDropdown, setIsActiveDropdown] = useState(false);
  const toastId = useRef();

  console.log("Active Attendees", activeAttendees);
  console.log("Event Schedules", schedules);

  const sendEvaluation = async (id) => {
    setIsActiveDropdown(false);
    toggleSendEmail();
  }
  return (
    <>
      <UploadForm handleUpload={handleUpload} />
      <Form readOnly={readOnly} activateForm={activateForm} onSubmit={onSubmit}>
        <div className="form__group event__form">
        {title && (
          <div className="form__title">
            <div className="form__title--text">{onBack && (
              <span className="back__button--icon" onClick={() => onBack()}><FontAwesomeIcon icon={faArrowLeft} /></span>
            )} {title}</div>
            {(activateForm || copyLink) && (
              <div className="form__title--configs">
              <div className="form__title--config" onClick={() => activateForm(true)}>
                {readOnly && (
                  <FontAwesomeIcon icon={faEdit} />
                )}
              </div>
                <div className="form__title--config" onClick={() => setIsActiveDropdown(true)}>
                  <FontAwesomeIcon icon={faEllipsisH} />
                </div>
                {isActiveDropdown && (
                  <div className="form__title--config-dropdown">
                    <a className="config-dropdown__item"href={`https://petros-global.com/ems/registration?ref=${magic_link}`} target="_blank">
                      Open Registration
                    </a>
                    <div className="config-dropdown__item" onClick={() => sendEvaluation(id)}>
                      Send Evaluations
                    </div>
                    <div className="config-dropdown__item" onClick={() => exportAttendees()}>
                      Export Attendees
                    </div>
                    <div className="config-dropdown__item" onClick={() => downloadCertificates(true)}>
                      Download Certificates
                    </div>
                    <a className="config-dropdown__item" href={`https://petros-global.com/uploads/BADGES.rar`} download target="_blank">
                      Download Badges
                    </a>
                    <a className="config-dropdown__item" onClick={() => toggleEvaluation()}>
                      Show Evaluation Results
                    </a>
                    <a className="config-dropdown__item" onClick={() => {
                      const uploadInput = document.querySelector(".event__upload--input");
                      uploadInput.click();
                      setIsActiveDropdown(false);
                    }}>
                      Upload Attendees
                    </a>
                  </div>
                )}

                {isActiveDropdown && (
                  <div className="form__title--config-overlay" onClick={() => setIsActiveDropdown(false)} />
                )}
              </div>
            )}
          </div>
        )}

          <div className="form__row">
            <div className="form__row--item">
              <Input
                defaultValue={name}
                label="Name"
                isRequired
                readOnly={readOnly}
                onChange={(value) => {
                  if (onChange) onChange("name", value);
                }}
              />
            </div>
            
            <div className="form__row--item">
              <Input
                type="select"
                label="Type"
                isRequired
                options={EVENT_TYPES}
                readOnly={readOnly}
                defaultValue={type}
                onChange={(value) => {
                  if (onChange) onChange("type", value);
                }}
              />
            </div>
          </div>

          <div className="form__row">
            {id && (
              <div className="form__row--item">
                <Input
                  type="select"
                  label="Status"
                  isRequired
                  options={EVENT_STATUSES}
                  readOnly={readOnly}
                  defaultValue={status}
                  onChange={(value) => {
                    if (onChange) onChange("status", value);
                  }}
                />
              </div>
            )}
            <div className="form__row--item">
              <Input
                label="Price"
                isRequired
                readOnly={readOnly}
                defaultValue={String(price || "")}
                onChange={(value) => {
                  if (onChange) onChange("price", parseFloat(value));
                }}
              />
            </div>
          </div>

          <div className="form__row">
            <div className="form__row--item">
              <Input
                type="textarea"
                label="Venue"
                isRequired
                readOnly={readOnly}
                defaultValue={venue}
                onChange={(value) => {
                  if (onChange) onChange("venue", value);
                }}
              />
            </div>
          </div>

          <div className="form__group">
            <div className="form__group--title">
              <span>Schedule</span>
              {!readOnly && (
                <span className="form__schedule--add-btn" onClick={() => {
                  if (onChange) onChange("schedules", JSON.stringify([...schedules, {}]));
                }}>
                  <FontAwesomeIcon icon={faPlus} />
                </span>
              )}
            </div>
            
            {schedules.map((scheduleItem = {}, index) => (
              <div className="form__row form__schedule--item" key={[scheduleItem.date, scheduleItem.timeIn, index].join("-")}>
                {!readOnly && (
                  <div
                    className="form__row--remove-btn"
                    onClick={() => {
                      if (onChange) onChange("schedules", JSON.stringify(schedules.filter((_, currIndex) => currIndex !== index)))
                    }}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </div>
                )}
                <div className="form__row--item">
                  <Input
                    type="date"
                    label={`Day ${index + 1}`}
                    isRequired
                    readOnly={readOnly}
                    defaultValue={scheduleItem.date ? formatDate(scheduleItem.date, { isoFormat: true }) : undefined}
                    onChange={(value) => {
                      const updatedSchedules = schedules.map((currSched, currIndex) => {
                        if (index !== currIndex) return currSched;

                        return {
                          ...scheduleItem,
                          date: value,
                        };
                      });

                      console.log("Updated Date schedules", updatedSchedules, value, "pl")

                      if (onChange) onChange("schedules", JSON.stringify(updatedSchedules));
                    }}
                  />
                </div>
                <div className="form__row--item">
                  <Input
                    type="time"
                    label="Time-In"
                    isRequired
                    readOnly={readOnly}
                    defaultValue={scheduleItem.timeIn}
                    onChange={(value) => {
                      const updatedSchedules = schedules.map((currSched, currIndex) => {
                        if (index !== currIndex) return currSched;

                        return {
                          ...scheduleItem,
                          timeIn: value,
                        };
                      });

                      if (onChange) onChange("schedules", JSON.stringify(updatedSchedules));
                    }}
                  />
                </div>
                <div className="form__row--item">
                  <Input
                    type="time"
                    label="Time-Out"
                    isRequired
                    readOnly={readOnly}
                    defaultValue={scheduleItem.timeOut}
                    onChange={(value) => {
                      const updatedSchedules = schedules.map((currSched, currIndex) => {
                        if (index !== currIndex) return currSched;

                        return {
                          ...scheduleItem,
                          timeOut: value,
                        };
                      });

                      if (onChange) onChange("schedules", JSON.stringify(updatedSchedules));
                    }}
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="form__group">
            <div className="form__group--title">
              <span>Covered Topics</span>
              {!readOnly && (
                <span className="form__schedule--add-btn" onClick={() => {
                  if (onChange) onChange("topics", JSON.stringify([...topics, ""]));
                }}>
                  <FontAwesomeIcon icon={faPlus} />
                </span>
              )}
            </div>

            {topics.map((topicItem, index) => (
                <div className="form__row form__schedule--item">
                  {!readOnly && (
                    <div
                      className="form__row--remove-btn"
                      onClick={() => {
                        if (onChange) onChange("topics", JSON.stringify(topics.filter((_, currIndex) => currIndex !== index)))
                      }}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </div>
                  )}
                  <div className="form__row--item">
                    <Input
                      type="text"
                      label={`Topic ${index + 1}`}
                      defaultValue={topicItem}
                      onChange={(value) => {
                        const updatedTopics = topics.map((currSched, currIndex) => {
                          if (index !== currIndex) return currSched;
    
                          return value;
                        });
    
                        if (onChange) onChange("topics", JSON.stringify(updatedTopics));
                      }}
                      readOnly={readOnly}
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>
      </Form>
    </>
  )
}

export default EventForm;